import { GridColDef } from '@mui/x-data-grid';
import {
    Box,
    TextField,
    Alert,
    InputAdornment,
    Typography,
    Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { atom } from 'jotai';
import React, { useState, useMemo, useEffect } from 'react';
import CommonDataGrid from '../../stateless/CommonDataGrid';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface ChoiceGroupDataType {
    storeType: any;
    choiceGroupNameEnglish: string;
    choiceGroupNameArabic: string;
    minimumLimit: number | null;
    maximumLimit: number | null;
    choiceDetails: any;
    choiceGroupOption: any;
    merchantDetails: any;
    id: any;
    storeId?: string;
}

export const choiceGroupAtom = atom<ChoiceGroupDataType | null>(null);

interface ManageChoicesGroupTableProps {
    storeId?: string;
}

const CommisionTractingHistory: React.FC<ManageChoicesGroupTableProps> = () => {
    const { t, i18n } = useTranslation();
    const [, forceUpdate] = useState({});
    const navigate = useNavigate();
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const snackbarMessage = ''; // Replace with actual message
    const snackbarSeverity: 'success' | 'error' | 'info' | 'warning' = 'info';

    // Force re-render when language changes
    useEffect(() => {
        const handleLanguageChange = () => {
            forceUpdate({});
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    const [searchTerm, setSearchTerm] = useState('');
    // const debouncedSearch = useDebounce(searchTerm, 400);

    // const { params, dispatch } = useGroupChoiceParams();
    // const isReady = Boolean(params && Object.keys(params).length > 0);

    // const memoizedParams = useMemo(() => {
    //   return isReady ? params : {};
    // }, [isReady, params]);
    // const { data: ChoiceGroupData, isLoading, refetch} = useAllChoiceGroup(memoizedParams)

    //   const filteredRows = React.useMemo(() => {
    //     if (!ChoiceGroupData?.data) return [];
    //     const storeOwners = ChoiceGroupData?.data || []

    //     return storeOwners.map((row, index) => ({
    //       ...row,
    //        id: row.choiceGroupId,
    //         sno: index + 1 + (Number(params.page - 1)) * Number(params.limit),
    //         name: row.storeName?? 'N/A',
    //         merchantType: row.storeType ?? 'N/A',
    //         ChoiceGroup: row.choiceGroupNameEnglish,
    //         minimumLimit: row.minimumLimit,
    //         maximumLimit: row.maximumLimit,
    //         choiceDetails: row.choiceDetails.map((detail) => detail.choiceId),
    //     }));
    //   }, [params.search, ChoiceGroupData, params.page, params.limit]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value)
    };

    //   useEffect(() => {
    //     dispatch({ type: 'SET_SEARCH', payload: debouncedSearch ? debouncedSearch : undefined });
    //   }, [debouncedSearch]);

    //   const handlePageChange = (newPage: number) => {
    //     dispatch({ type: 'SET_PAGE', payload: newPage + 1 });
    //   };

    //   const handlePageSizeChange = (newSize: number) => {
    //     dispatch({ type: 'SET_LIMIT', payload: newSize });
    //   };

    // const handleFilterChange = (sortBy: string, sortOrder: 'asc' | 'desc') => {
    //   dispatch({ type: 'SET_SORT', payload: { sortBy, sortOrder } });
    // };




    //   const totalItems = params.search
    //     ? filteredRows.length
    //     : ChoiceGroupData?.pagination?.totalItems || 0

    const columns = useMemo<GridColDef[]>(() => [
        {
            field: 'sno',
            headerName: t('commissionTracking.history.columns.sno'),
            flex: 0.3,
        },
        {
            field: 'merchantEmail',
            headerName: t('commissionTracking.history.columns.merchantEmail'),
            flex: 2,
        },
        {
            field: 'merchantName',
            headerName: t('commissionTracking.history.columns.merchantName'),
            flex: 2,
        },
        {
            field: 'transactionId',
            headerName: t('commissionTracking.history.columns.transactionId'),
            flex: 1,
        },
        {
            field: 'adminPaidAmounttoMerchant',
            headerName: t('commissionTracking.history.columns.adminPaidAmounttoMerchant'),
            flex: 1,
        },
        {
            field: 'paidDate',
            headerName: t('commissionTracking.history.columns.paidDate'),
            flex: 1,
        },
        {
            field: 'payType',
            headerName: t('commissionTracking.history.columns.payType'),
            flex: 1,
        },
    ], [t]);

    // Format the manageStoreData for the DataGrid

  const filteredRows = [
  {
    id: 1,
    sno: 1,
    merchantEmail: "john@spicybites.com",
    merchantName: "Spicy Bites",
    transactionId: "TXN123456",
    adminPaidAmounttoMerchant: 850,
    paidDate: "2025-07-20",
    payType: "Bank Transfer",
  },
  {
    id: 2,
    sno: 2,
    merchantEmail: "sara@greenkitchen.com",
    merchantName: "Green Kitchen",
    transactionId: "TXN987654",
    adminPaidAmounttoMerchant: 720,
    paidDate: "2025-07-18",
    payType: "UPI",
  },
  {
    id: 3,
    sno: 3,
    merchantEmail: "mike@urbanfoods.com",
    merchantName: "Urban Foods",
    transactionId: "TXN445566",
    adminPaidAmounttoMerchant: 1020,
    paidDate: "2025-07-19",
    payType: "NEFT",
  },
  {
    id: 4,
    sno: 4,
    merchantEmail: "lisa@tandoorixpress.com",
    merchantName: "Tandoori Xpress",
    transactionId: "TXN223344",
    adminPaidAmounttoMerchant: 630,
    paidDate: "2025-07-17",
    payType: "Cash",
  },
];

  const handleRowSelection = (selectionModel: any) => {
    setSelectedRows(selectionModel);
  };

     const handleBackClick = () => {
        navigate('/layout/commissionTracking');
    };



    return (
        <>
            <Typography variant="h5" fontWeight="bold" mb={2}>
                {t('commissionTracking.history.title')}
            </Typography>
            <Box
                sx={{
                    p: 2,
                    border: '1px solid #e0e0e0',
                    marginTop: '20px',
                    color: '#666',
                }}
            >
                {snackbarOpen && (
                    <Box sx={{ mb: 2 }}>
                        <Alert
                            severity={snackbarSeverity}
                            onClose={() => setSnackbarOpen(false)}
                        >
                            {snackbarMessage}
                        </Alert>
                    </Box>
                )}
                <Box
                    sx={{
                        // p: 2,
                        mb: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 2, // Optional: adds spacing between wrapped items
                    }}
                >
                    {/* Search - Left */}
                    <Box
                        sx={{
                            width: 600,
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            background: '#fff',
                        }}
                    >
                        <TextField
                            fullWidth
                            placeholder={t('commissionTracking.history.searchPlaceholder')}
                            size="medium"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            sx={{
                                '.MuiOutlinedInput-root': {
                                    height: 40,
                                    width: 600,
                                    border: 'none', // remove inner border
                                },
                                '& fieldset': {
                                    border: 'none', // remove Material-UI default border
                                },
                                '& .MuiInputBase-input': {
                                    paddingTop: '10px', // adjust this value to move the placeholder lower
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            sx={{ fontSize: 20, color: '#aaa', mt: '4px' }}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                   {/* Action Buttons + Add Button - Right */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            flexWrap: 'wrap',
                        }}
                    >
                        <Button
                            variant="contained"
                            startIcon={<ArrowBackIcon />}
                            onClick={handleBackClick}
                            color="primary"
                        >
                            {t('commissionTracking.history.back')}
                        </Button>
                    </Box>
                </Box>

                {/* <CommonDataGrid
                      key={`datagrid-page-${params.page}-limit-${params.limit}`}
                    rows={filteredRows || []}
                    columns={columns}
                      pageSize={params.limit}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePageSizeChange}
                      checkboxSelection
                      loading={isLoading}
                      page={params.page - 1}
                      rowCount={CMSData?.pagination?.totalItems}
                      components={{
                        NoRowsOverlay: () => <ErrorHandler type="no-data" message="No categories found" onRetry={() => refetch()} />
                      }}
                    onRowSelectionModelChange={(ids: string[]) => setSelectedRows(ids)}
                    selectionModel={selectedRows} pageSize={0} onPageSizeChange={function (): void {
                        throw new Error('Function not implemented.');
                    }} components={undefined}
                     /> */}
                      <CommonDataGrid
                        rows={filteredRows}
                        columns={columns}
                        pageSize={10}
                        onPageSizeChange={() => { }}
                        loading={false}
                        components={{}}
                        checkboxSelection
                        onRowSelectionModelChange={handleRowSelection}
                        selectionModel={selectedRows}
                      />
            </Box>
        </>
    );
};

export default CommisionTractingHistory;

